var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "256px",
    height: "256px",
    viewBox: "0 0 24 24",
    id: "image-frame",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M4,4H20a1,1,0,0,1,1,1V15.73L15.29,10,10.51,14.8,7.71,12,3,16.71V5A1,1,0,0,1,4,4Z",
    style: {
      fill: "#2ca9bc",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke",
    x1: 10.08,
    y1: 8.29,
    x2: 10.18,
    y2: 8.29,
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M10.51,14.8l5.2,5.2H20a1,1,0,0,0,1-1V15.73L15.29,10ZM3,16.71V19a1,1,0,0,0,1,1H15.71l-8-8ZM21,5V19a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V5A1,1,0,0,1,4,4H20A1,1,0,0,1,21,5Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.33f52a9f7774a53a88dc9faab6c5401e.svg";
export { ForwardRef as ReactComponent };